import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
	MaterialEventsType,
	MaterialFilterListType,
	MaterialListType,
} from "./types/types";
import baseQueryWithReAuth from "../../services/utils.service/baseQueryWithReAuth";

export const materialEventsApi = createApi({
	reducerPath: "materialEventsApi",
	baseQuery: baseQueryWithReAuth,
	endpoints: (builder) => ({
		getMaterialEvents: builder.query<MaterialEventsType, number>({
			query: (id) => `/v2/materials/${id}`,
		}),
		/////////////////////////////////////////
		getMaterialList: builder.query<MaterialListType, void>({
			query: () => `/v2/materials/my`,
		}),
		getMaterialFilterList: builder.query<MaterialFilterListType, void>({
			query: () => `/v2/materials/my/filter`,
		}),
		/////////////////////////////////////////////////////////////
		updateMaterialEvents: builder.mutation<
			MaterialEventsType,
			{ id: number; lessonId: number; isDone: boolean }
		>({
			query: ({ id, lessonId, isDone }) => ({
				url: `/v2/materials/${id}/lessons/${lessonId}/done`,
				method: "PUT",
				body: { isDone },
			}),
		}),
	}),
});

export const {
	useGetMaterialEventsQuery,
	useGetMaterialListQuery,
	useGetMaterialFilterListQuery,
	useUpdateMaterialEventsMutation,
} = materialEventsApi;
